import { urlUtils, queryKeys } from '../../utils/url';
import * as ACTIONS from '../actionTypes/cruiseListActionTypes';

const actionsWithQueryUpdate = [
  ACTIONS.CLEAR_FILTERS,
  ACTIONS.CLEAR_SINGLE_FILTER,
  ACTIONS.INIT_SUCCESS,
  ACTIONS.SELECT_FILTER_CRUISE_CATEGORY,
  ACTIONS.SELECT_FILTER_DEPARTURE_MONTH,
  ACTIONS.SELECT_FILTER_DESTINATION,
  ACTIONS.SELECT_FILTER_DURATION,
  ACTIONS.SELECT_FILTER_NUMBER_OF_DESTINATIONS,
  ACTIONS.SELECT_FILTER_SHIP_RATING,
  ACTIONS.SELECT_FILTER_SHIPPING_COMPANY,
  ACTIONS.SORT_CRUISE_LIST,
];

const cruiseListQueryMiddleware = store => next => action => {
  next(action);

  if (actionsWithQueryUpdate.includes(action.type)) {
    const state = store.getState();

    switch (action.type) {
      case ACTIONS.INIT_SUCCESS: {
        if (!action.preSelectedFilter) {
          break;
        }
        const filterState = urlUtils.getFilterStateFromQueryByFiltersType(queryKeys.CRUISE_FILTERS, action.preSelectedFilter);
        urlUtils.updateQueryWithValues(filterState);
        break;
      }
      case ACTIONS.SORT_CRUISE_LIST: {
        urlUtils.updateUrlWithSortKey(action.sortBy);
        break;
      }
      case ACTIONS.SELECT_FILTER_DEPARTURE_MONTH: {
        const selectedDepartureMonths = state.getIn(['filter', 'filterGroups', 'departureMonth', 'selected']);

        urlUtils.updateQueryWithValues({
          [queryKeys.CRUISE_FILTERS.departureMonth]: selectedDepartureMonths.join(),
        });
        break;
      }
      case ACTIONS.SELECT_FILTER_SHIP_RATING: {
        const selectedShipRating = state.getIn(['filter', 'filterGroups', 'shipRating', 'selected']);

        urlUtils.updateQueryWithValues({
          [queryKeys.CRUISE_FILTERS.shipRating]: selectedShipRating.join(),
        });
        break;
      }
      case ACTIONS.SELECT_FILTER_DURATION: {
        const minDuration = state.getIn(['filter', 'filterGroups', 'duration', 'minValue']);
        const maxDuration = state.getIn(['filter', 'filterGroups', 'duration', 'maxValue']);

        const selectedMinDuration = state.getIn(['filter', 'filterGroups', 'duration', 'selectedMinValue']);
        const selectedMaxDuration = state.getIn(['filter', 'filterGroups', 'duration', 'selectedMaxValue']);

        const selectedValuesAreNotDefault =
          selectedMinDuration !== minDuration ||
          selectedMaxDuration !== maxDuration;

        urlUtils.updateQueryWithValues({
          [queryKeys.CRUISE_FILTERS.duration]: selectedValuesAreNotDefault
            ? `${selectedMinDuration},${selectedMaxDuration}`
            : undefined,
        });
        break;
      }
      case ACTIONS.SELECT_FILTER_CRUISE_CATEGORY: {
        const selectedCruiseCategory = state.getIn(['filter', 'filterGroups', 'cruiseCategory', 'selected']);

        urlUtils.updateQueryWithValues({
          [queryKeys.CRUISE_FILTERS.cruiseCategory]: selectedCruiseCategory.join(),
        });
        break;
      }
      case ACTIONS.SELECT_FILTER_DESTINATION: {
        const selectedDestination = state.getIn(['filter', 'filterGroups', 'destination', 'selected']);

        urlUtils.updateQueryWithValues({
          [queryKeys.CRUISE_FILTERS.destination]: selectedDestination.join(),
        });
        break;
      }
      case ACTIONS.SELECT_FILTER_NUMBER_OF_DESTINATIONS: {
        const minNumberOfDest = state.getIn(['filter', 'filterGroups', 'destination', 'minNumberOfDestinations']);
        const maxNumberOfDest = state.getIn(['filter', 'filterGroups', 'destination', 'maxNumberOfDestinations']);

        const selectedMinNumberOfDest = state.getIn(['filter', 'filterGroups', 'destination', 'selectedMinNumberOfDestinations']);
        const selectedMaxNumberOfDest = state.getIn(['filter', 'filterGroups', 'destination', 'selectedMaxNumberOfDestinations']);

        const selectedValuesAreNotDefault =
          selectedMinNumberOfDest !== minNumberOfDest ||
          selectedMaxNumberOfDest !== maxNumberOfDest;

        urlUtils.updateQueryWithValues({
          [queryKeys.CRUISE_FILTERS.numberOfDestinations]:
            selectedValuesAreNotDefault
              ? `${selectedMinNumberOfDest},${selectedMaxNumberOfDest}`
              : undefined,
        });
        break;
      }
      case ACTIONS.SELECT_FILTER_SHIPPING_COMPANY: {
        const selectedShippingCompany = state.getIn(['filter', 'filterGroups', 'shippingCompany', 'selected']);

        urlUtils.updateQueryWithValues({
          [queryKeys.CRUISE_FILTERS.shippingCompany]: selectedShippingCompany.join(),
        });
        break;
      }
      case ACTIONS.CLEAR_FILTERS: {
        const filterQueriesToRemove = {};

        Object.keys(queryKeys.CRUISE_FILTERS).forEach((queryKey) => {
          filterQueriesToRemove[queryKeys.CRUISE_FILTERS[queryKey]] = undefined;
        });

        urlUtils.updateQueryWithValues(filterQueriesToRemove);
        break;
      }
      case ACTIONS.CLEAR_SINGLE_FILTER: {
        const filterQueriesToRemove = {};

        filterQueriesToRemove[queryKeys.CRUISE_FILTERS[action.filterGroupKey]] = undefined;

        urlUtils.updateQueryWithValues(filterQueriesToRemove);
        break;
      }
      default:
    }
  }
};

export default cruiseListQueryMiddleware;